import { AppHome } from '../types';

export const FETCH_APP_HOME_SUCCESS = 'FETCH_APP_HOME_SUCCESS';

export interface AppHomeResponse {
    appId: string;
    appHome: AppHome;
}

export interface FetchAppHomeSuccessAction {
    type: typeof FETCH_APP_HOME_SUCCESS;
    payload: AppHomeResponse;
}

export const fetchAppHomeSuccess: (payload: AppHomeResponse) => FetchAppHomeSuccessAction = (payload) => {
    return {
        type: FETCH_APP_HOME_SUCCESS,
        payload,
    };
};
